import React from "react";
import InputMask from "react-text-mask";
function isMutableRefObject(ref) {
  return Boolean(ref && "current" in ref);
}
export default React.forwardRef((topLevelProps, ref) => /* @__PURE__ */ React.createElement(InputMask, {
  render: (textMaskRef, props) => /* @__PURE__ */ React.createElement("input", {
    ...props,
    ref: (node) => {
      if (!node)
        return;
      textMaskRef(node);
      if (isMutableRefObject(ref)) {
        ref.current = node;
      }
    }
  }),
  ...topLevelProps
}));
